import xhrService from "../xhrService";

const baseUrl = `/api/project-inspection-schedulers`;

type SchedulerApi = {
    getProjectSchedule: (params: any) => Promise<any>;
    createProjectSchedule: (body: any) => Promise<any>;
    updateProjectSchedule: (id: number, body: any) => Promise<any>;
    getUpcomingInspections: (projectId: number) => Promise<any>;
    getProjectForms: (projectId: number) => Promise<any>;
    getProjectRoutines: (divisionId: number, projectId: number) => Promise<any>;
    updateNextInspectionDate: (junctionId: number, body: { next_inspection_date: string }) => Promise<any>;
    updateRoutineSettings: (junctionId: number, body: any) => Promise<any>;
    createProjectInspectionTemplate: (body: any) => Promise<any>;
    getRoutineEditOptions: (routineId: number) => Promise<any>;
};

const schedulerApi: SchedulerApi = {
    getProjectSchedule: (projectId) => {
        return xhrService
            .get(`${baseUrl}/by_project_id/${projectId}`)
            .then((res) => res.data);
    },
    createProjectSchedule: (body) => {
        return xhrService
            .post(`${baseUrl}`, body)
            .then((res) => res.data);
    },
    updateProjectSchedule: (id, body) => {
        return xhrService
            .put(`${baseUrl}/${id}`, body)
            .then((res) => res.data);
    },
    getUpcomingInspections: (projectId) => {
        return xhrService
            .get(`${baseUrl}/project/${projectId}/upcoming`)
            .then((res) => res.data);
    },
    getProjectForms: (projectId) => {
        return xhrService
            .get(`${baseUrl}/project/${projectId}/forms`)
            .then((res) => res.data);
    },
    getProjectRoutines: (divisionId, projectId) => {
        return xhrService
            .get(`${baseUrl}/division/${divisionId}/project/${projectId}/routines`)
            .then((res) => res.data);
    },
    updateNextInspectionDate: (junctionId, body) => {
        return xhrService
            .put(`${baseUrl}/routines/${junctionId}/next-inspection-date`, body)
            .then((res) => res.data);
    },
    updateRoutineSettings: (junctionId, body) => {
        return xhrService
            .put(`${baseUrl}/routines/${junctionId}`, body)
            .then((res) => res.data);
    },
    createProjectInspectionTemplate: (body) => {
        return xhrService
            .post(`${baseUrl}/routines`, body)
            .then((res) => res.data);
    },
    getRoutineEditOptions: (routineId) => {
        return xhrService
            .get(`${baseUrl}/routines/${routineId}/edit-options`)
            .then((res) => res.data);
    },
};

export default schedulerApi;
